<template>
    <modal ref="confirm" @closed="cancel()">
        <div class="modal-body">
            {{ title }}
        </div>
        <div class="modal-footer">
            <button class="btn btn-secondary" v-on:click.prevent="cancel()">{{ cancelButtonText }}</button>
            <button class="btn btn-primary" v-on:click.prevent="confirm()">{{ confirmButtonText }}</button>
        </div>
    </modal>
</template>
<script>
export default {
    props: {
        title: {
            type: String,
            required: false,
            default: "Confirm"
        },
        confirmButtonText: {
            type: String,
            required: false,
            default: "OK"
        },
        cancelButtonText: {
            type: String,
            required: false,
            default: "Cancel"
        }
    },
    data() {
        return {
            confirmCallback: null,
            cancelCallback: null
        };
    },
    methods: {
        confirm() {
            // only call confirm callback, avoid cancel callback
            this.cancelCallback = null;

            // close confirm modal
            this.$refs.confirm.close();

            if (this.confirmCallback) {
                this.confirmCallback();
            }
        },
        open(confirmCallback, cancelCallback) {
            this.$refs.confirm.open();

            this.confirmCallback = confirmCallback;
            this.cancelCallback = cancelCallback;
        },
        cancel() {
            this.$refs.confirm.close();

            // cancel callback - do not call twice
            if (this.cancelCallback) {
                this.cancelCallback();
                this.cancelCallback = null;
            }
        }
    }
};
</script>
<style lang="scss">
.confirm-text {
    max-width: 400px;
}
</style>
